import React from "react";

/**
 * Gère le rafraîchissement manuel et automatique d'une source de données.
 *
 * @param {Function} fetchFn  - fonction async à appeler pour rafraîchir
 * @param {Object}   options
 * @param {boolean}  options.autoRefreshDefault  - activé par défaut (false)
 * @param {number}   options.intervalDefault     - intervalle par défaut en ms (10000)
 */
export function useAutoRefresh(fetchFn, { autoRefreshDefault = false, intervalDefault = 10000 } = {}) {
    const [autoRefresh, setAutoRefresh] = React.useState(autoRefreshDefault);
    const [intervalMs,  setIntervalMs]  = React.useState(intervalDefault);
    const [refreshing,  setRefreshing]  = React.useState(false);

    // Ref stable vers fetchFn pour éviter de reset l'interval à chaque render
    const fetchRef = React.useRef(fetchFn);
    React.useEffect(() => { fetchRef.current = fetchFn; }, [fetchFn]);

    // Auto-refresh
    React.useEffect(() => {
        if (!autoRefresh) return;
        const id = setInterval(() => fetchRef.current(), intervalMs);
        return () => clearInterval(id);
    }, [autoRefresh, intervalMs]);

    // Refresh manuel avec spinner
    const manualRefresh = React.useCallback(async () => {
        setRefreshing(true);
        try { await fetchRef.current(); } finally { setRefreshing(false); }
    }, []);

    return { autoRefresh, setAutoRefresh, intervalMs, setIntervalMs, refreshing, manualRefresh };
}

